import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MeetList } from '@athleticnet/athletic-live-api-models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocaleToggleComponent } from '../../shared/locale-toggle/locale-toggle.component';
import { CurrentMeetService } from '../../shared/services/current-meet.service';
import { IsDesktopService } from '../../shared/services/is-desktop.service';
import { TimezoneToggleComponent } from '../../shared/timezone-toggle/timezone-toggle.component';
import { FollowListComponent } from '../follow-list/follow-list.component';

@Component({
  selector: 'app-sidebar-home',
  templateUrl: './sidebar-home.component.html',
  styleUrls: ['./sidebar-home.component.scss'],
  imports: [
    FontAwesomeModule,
    AsyncPipe,
    TimezoneToggleComponent,
    FollowListComponent,
    NgbAccordionModule,
    LocaleToggleComponent,
  ],
})
export class SidebarHomeComponent {
  currentMeet$!: Observable<MeetList | null>;
  desktop$!: Observable<boolean>;

  constructor(
    private currentMeetService: CurrentMeetService,
    private isDesktopService: IsDesktopService,
  ) {}

  ngOnInit() {
    this.desktop$ = this.isDesktopService.isDesktop;
    this.currentMeet$ = this.currentMeetService.updateMeet;
  }

  protected readonly environment = environment;
}
